(ns nl.mediquest.ui.core.page
  (:require
   [clojure.spec.alpha :as s]
   [integrant.core :as ig]
   [meta-merge.core :refer [meta-merge]]
   [nl.mediquest.ui.core.modal :as modal]
   [nl.mediquest.ui.css :refer [inject-styles!]]
   [re-frame.core :as re-frame]))

(s/def :page/header fn?)
(s/def :page/body fn?)
(s/def :page/footer fn?)
(s/def :page/before-body fn?)
(s/def :page/after-body fn?)
(s/def :page/modal fn?)
(s/def :page/title (s/nilable (s/or :string string?
                                    :fn fn?)))
(s/def :page/breadcrumb-title (s/nilable (s/or :string string?
                                               :fn fn?)))

(defn styles [{:page/keys [color-schemes default-color-scheme]}]
  (when-let [scheme (get color-schemes default-color-scheme)]
    [[":root" scheme]]))

(defn set-page-title! [{:page/keys [title]}]
  (when title
    (set! js/document.title title)))

(defn page-view
  [params {:page/keys [header body footer before-body after-body modal notifications context]}]
  [:<>
   (when notifications
     [notifications])
   (when modal [modal])
   [:div
    (when-let [_active-modal @(re-frame/subscribe [::modal/modal])]
      {:on-click modal/close!})
    (when header [header])
    [:div
     (when header
       {:class [:absolute :top-16 :right-0 :bottom-0 :left-0 :overflow-y-scroll]})
     [:div.flex.flex-col.min-h-full.bg-gray-100
      (when before-body [before-body])
      [body context params]
      (when after-body [after-body])
      (when footer [footer])]]]])

(defn add-title-to-context [{:page/keys [title breadcrumb-title context] :as opts} params]
  (let [title (if (fn? title) (title context params) title)
        breadcrumb-title (if (fn? breadcrumb-title) (breadcrumb-title context params) breadcrumb-title)]
    (-> opts
        (assoc :page/title title
               :page/breadcrumb-title breadcrumb-title)
        (assoc-in [:page/context :page/title] title)
        (assoc-in [:page/context :page/breadcrumb-title] breadcrumb-title))))

(defn view [{:page/keys [default] :as opts} params]
  (let [opts (meta-merge default opts)]
    (when-let [styles' (styles opts)]
      (inject-styles! ::styles styles'))
    (let [opts (add-title-to-context opts params)]
      (set-page-title! opts)
      [page-view params opts])))

(defmethod ig/assert-key :component.ui/page [_k v]
  (assert (s/valid? (s/keys :opt [:page/header
                                  :page/body
                                  :page/footer
                                  :page/before-body
                                  :page/after-body
                                  :page/modal
                                  :page/title
                                  :page/breadcrumb-title])
                    v)))

(defmethod ig/init-key :component.ui/page [_ opts]
  (fn [params]
    [view opts params]))
